export default "__VITE_ASSET__BLAAG7Wq__"